import React from 'react';
import ReactDOM from 'react-dom';

import FontSizeOption from '../app/components/blocks/FontSizeOption.jsx';

const root = document.getElementById('font-size-option');

if (root) {
  ReactDOM.render(
    <FontSizeOption />,
    root,
  );
}
